import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";

export const BasicMuiTable = ({ data, columns, tableFooter }) => {
  return (
    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead sx={{ backgroundColor: "#F5F8FC" }}>
          <TableRow
            sx={{
              ".css-191a0o-MuiTableCell-root": {
                padding: "10px 8px",
              },
            }}
          >
            {columns.map((item) => (
              <TableCell
                sx={{
                  ...item.meta,
                  width: item.meta || "auto",
                  minWidth: item.meta?.minWidth || "auto",
                }}
              >
                {item.header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              {columns.map((column) => (
                <TableCell
                  sx={{
                    ...item.meta,
                    width: item.meta?.width || "auto",
                    minWidth: item.meta?.minWidth || "auto",
                  }}
                >
                  {column.cell(item, index)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TableFooter>{tableFooter}</TableFooter>
    </TableContainer>
  );
};
